import { setSession } from "@/src/auth/store/auth.slice";
import { initializeAuth, refreshProfile } from "@/src/auth/store/auth.thunks";
import { store } from "@/src/common/redux/store";
import { supabase } from "@/src/common/services/supabase.service";

let bootstrapped = false;

/**
 * Bootstrap the auth domain: subscribe to Supabase auth state changes
 * and hydrate the session on page load. The auth slice itself is
 * statically registered in the root store, and the i18n bundle is
 * registered centrally in `@/src/common/locales/en`.
 */
function bootstrap(): void {
	if (bootstrapped) return;
	bootstrapped = true;

	supabase.auth.onAuthStateChange((event, session) => {
		store.dispatch(setSession(session));
		if (session && (event === "SIGNED_IN" || event === "TOKEN_REFRESHED" || event === "USER_UPDATED")) {
			void store.dispatch(refreshProfile());
		}
	});

	void store.dispatch(initializeAuth());
}

bootstrap();
